import * as React from "react";
import { Controller } from "react-hook-form";
import { IInput } from "../types/dataForm/types";
import { Checkbox, FormControlLabel } from "@mui/material";

export default function InputCheckbox({
  name,
  form,
  label,
  mb = 2,
}: IInput) {
  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          label={label}
          control={
            <Controller
              name={name}
              render={({}) => {
                return (
                  <Checkbox checked={value} onChange={onChange} sx={{ mb }} />
                );
              }}
              control={form.control}
            />
          }
        />
      )}
    />
  );
}
